import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import Select from '../Select';
import ContextMenu from '../ContextMenu';
import CircleIcon from '../CircleIcon';
import { responsiveShow, responsiveHide } from '../../style';

const BaseSelect = styled(Select)`
  ${responsiveShow.tablet}

  > .select {
    width: ${({ style }) => (style ? style.width : 200)}px;

    .select-label {
      line-height: 14px;
      max-width: 95%;
    }

    .select-input {
      min-height: 24px;
      padding: 5px 10px;
    }

    .select-arrow {
      right: 12px;
    }
  }
`;

const NON_CLICKABLE_OPTION_CSS = css`
  font-weight: 600;
  cursor: default;
`;

const BaseContextMenu = styled(ContextMenu)`
  ${responsiveHide.tablet}
`;

const SelectHeader = ({ icon, ...props }) => {
  const { options, onChange } = props;
  const clickableOptions = useMemo(
    () =>
      options.map((option) =>
        option.clickable === false
          ? { ...option, onClick: undefined, closeOnClick: false, css: NON_CLICKABLE_OPTION_CSS }
          : { ...option, onClick: () => onChange(option.value) }
      ),
    [onChange, options]
  );

  return (
    <>
      <BaseSelect style={props.style} {...props} usePortal />
      <BaseContextMenu {...props} options={clickableOptions}>
        {icon && <CircleIcon icon={icon} />}
      </BaseContextMenu>
    </>
  );
};

export default SelectHeader;
